// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__bsLaK","selected":"styles_selected__4l3N+"};